module.exports = __webpack_public_path__ + "static/img/logoKN.154a2d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logoKN.png
// module id = bZmi
// module chunks = 1